import { useEffect, useState } from 'react';
import { Row, Button, Space, Col, Spin } from 'antd';
import PropTypes from 'prop-types';
import { DownOutlined } from '@ant-design/icons';
import EbzTable from 'components/EbzTable';
import './RegularPayoutSegment.scss';
import Alert from 'components/Alert';
import EbzFilterGroup from 'components/EbzFilterGroup';
import EbzPopover from 'components/EbzPopover';
import EbzButton from 'components/EbzButton';
import payoutReportsAPI from 'services/payoutApi';
import { InvoiceIconSvgIcon } from 'utils/icons';
import IncompleteKycModal from 'pages/NewPayoutReportListPage/IncompleteKycModal/IncompleteKycModal';
import BulkInvoiceModal from 'pages/NewPayoutReportListPage/InvoiceUploadModal/InvoiceUploadModal';
import PayoutReportViewDetails from '../../PayoutReportTab/PayoutReportViewDetails';
import {
  getRegularBasedPayoutReport,
  RegularPayoutReportfiltersArr,
  RegularSearchArr
} from './const';

function RegularPayoutSegment({ yearMonth }) {
  const [openModal, setModalOpen] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [regularSummaryReports, setRegularSummaryReports] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [currentView, setCurrentView] = useState(null);
  const [customFilters, setCustomFilters] = useState({});
  const [invoiceSummaryModal, setInvoiceSummaryModal] = useState(false);
  const [requestRaiseModal, setRequestRaiseModal] = useState(false);
  const [completeKyc, setCompleteKyc] = useState(false);
  const [hasRegularPayout, setHasRegularPayout] = useState(false);
  const [pendingInvoiceIDs, setPendingInvoiceIDs] = useState([]);
  const [canDownloadInvoiceIds, setcanDownloadInvoiceIds] = useState([]);
  const [downloadReport, setDownloadReport] = useState(false);
  const [invoiceSummary, setInvoiceSummary] = useState([]);
  const [kycModal, setKycModal] = useState(false);
  const [invoiceSummaryLoading, setInvoiceSummaryLoading] = useState(false);

  const fetchtRegularPayoutReports = async (filtersCheck) => {
    setTableLoading(true);
    const request = {
      filters: filtersCheck,
      mandatory_check: {
        year_month: yearMonth
      },
      payout_report_key: 'REGULAR'
    };
    const response = await payoutReportsAPI.getSceneriosBasedPayouts(request);
    if (!response?.success) {
      Alert('something went wrong', 'Please contact support team for this', 'error');
      setTableLoading(false);
    }
    setHasRegularPayout(response?.data?.fetch_payout_reports?.length > 0);
    setRegularSummaryReports(response?.data?.fetch_payout_reports);
    setPendingInvoiceIDs(
      response?.data?.fetch_payout_reports
        .filter((v) => [true].includes(v?.can_upload_invoice))
        .map(({ _id: id }) => id)
    );
    setcanDownloadInvoiceIds(
      response?.data?.fetch_payout_reports
        .filter((v) => v?.invoice_status === 'PARTNER_INVOICE_UPLOADED')
        .map(({ _id: id }) => id)
    );
    setCompleteKyc(response?.data?.is_kyc_complete);
    setTableLoading(false);
  };

  const clearFiltersCallBackfun = () => {
    setModalOpen(!openModal);
    fetchtRegularPayoutReports();
  };

  const applyFiltersCallbackfunc = (checkFilters) => {
    setModalOpen(!openModal);
    const cleanedFilters = checkFilters.filter(
      (item) => item != null && Object.keys(item).length > 0
    );
    const mergedDict = cleanedFilters.reduce(
      (prevObj, currentObj) => ({ ...prevObj, ...currentObj }),
      {}
    );
    setCustomFilters(mergedDict);
    fetchtRegularPayoutReports(mergedDict);
  };

  const handleViewDetails = (record) => {
    setOpenDrawer(!openDrawer);
    setCurrentView(record);
  };

  const handleKycModal = () => {
    setKycModal(!kycModal);
  };

  const handleAcceptInvoice = () => {
    if (completeKyc) {
      setInvoiceSummaryModal(!invoiceSummaryModal);
      setInvoiceSummary([]);
    } else {
      handleKycModal();
    }
  };

  const handleRaiseRequestModal = (value) => {
    setRequestRaiseModal(!requestRaiseModal);
    console.log(value);
  };

  const handleUploadInvoice = async (payload) => {
    setInvoiceSummaryLoading(true);
    const response = await payoutReportsAPI.bulkInvoiceSubmit(payload, {
      'content-type': 'multipart/form-data'
    });

    if (response?.success) {
      handleRaiseRequestModal(true, 'Invoice');
      setInvoiceSummaryModal(false);
      setInvoiceSummaryLoading(true);
      fetchtRegularPayoutReports();
    } else {
      setInvoiceSummaryModal(false);
      Alert(response?.message, 'Please contact support team for this', 'error');
    }
  };

  const downloadInvoice = async () => {
    setDownloadReport(true);
    let request = {};
    request = {
      // ...filters, two filter will be added cummaltive wala or on this page filters
      filters: customFilters,
      download_key: 'INVOICE',
      mandatory_check: {
        year_month: yearMonth
      },
      payout_report_key: 'REGULAR'
    };
    const response = await payoutReportsAPI.downloadBulkReports(request);
    if (response.success) {
      window.open(response?.data?.s3_url);
    } else {
      console.log('something went wrong');
      Alert('something went wrong', 'Please contact support team for this', 'error');
    }
    setDownloadReport(false);
  };

  const scenerioPayoutColumns = getRegularBasedPayoutReport(handleViewDetails);

  useEffect(() => {
    fetchtRegularPayoutReports();
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Col>
          <Space>
            <EbzPopover
              placement="bottomLeft"
              content={
                <EbzFilterGroup
                  searchParams={RegularSearchArr}
                  filters={RegularPayoutReportfiltersArr}
                  disableToday
                  apply={applyFiltersCallbackfunc}
                  clear={clearFiltersCallBackfun}
                />
              }
              open={openModal}
              onOpenChange={setModalOpen}
              trigger="click"
              overlayStyle={{
                width: '400px'
              }}
              overlayClassName="ebz-filters-popover"
            >
              <EbzButton size="large" className="ebz-filters-btn">
                Search & Filter
                <DownOutlined />
              </EbzButton>
            </EbzPopover>
          </Space>
        </Col>
        <Col style={{ display: 'flex', flexDirection: 'row', gap: '24px' }}>
          <Button
            size="medimum"
            style={{
              borderColor:
                canDownloadInvoiceIds?.length > 0
                  ? 'var(--color-primary)'
                  : 'var(--color-disabled)',
              cursor: canDownloadInvoiceIds?.length > 0 ? 'pointer' : 'not-allowed'
            }}
            loading={downloadReport}
            disabled={!canDownloadInvoiceIds?.length > 0}
            href="#"
            icon={
              <InvoiceIconSvgIcon
                style={{
                  color:
                    canDownloadInvoiceIds?.length > 0
                      ? 'var(--color-primary)'
                      : 'var(--color-disabled)',
                  cursor: canDownloadInvoiceIds?.length > 0 ? 'pointer' : 'not-allowed'
                }}
              />
            }
            onClick={() => downloadInvoice()}
          />
          <Button
            onClick={() => handleAcceptInvoice()}
            type="primary"
            disabled={pendingInvoiceIDs?.length === 0}
            style={{
              cursor: pendingInvoiceIDs?.length === 0 ? 'not-allowed' : 'pointer'
            }}
          >
            <Space>Bulk Upload Invoice</Space>
          </Button>
        </Col>
      </Row>
      <Spin spinning={tableLoading}>
        <Row>
          <EbzTable
            columns={scenerioPayoutColumns}
            // eslint-disable-next-line no-underscore-dangle
            rowKey={(r) => `${r.title}_type`}
            dataSource={hasRegularPayout ? regularSummaryReports : []}
            loading={false}
            pagination={false}
            isPagination={false}
            thBgColor="#EEEDF1"
            sticky
            size="medimum"
            scroll={hasRegularPayout && { x: 2000, y: 300, scrollToFirstRowOnChange: true }}
          />
        </Row>
      </Spin>

      <PayoutReportViewDetails
        viewMoreModal={openDrawer}
        handleViewDetails={handleViewDetails}
        currentView={currentView}
      />

      <BulkInvoiceModal
        pendingInvoiceIDs={pendingInvoiceIDs}
        invoiceSummaryModal={invoiceSummaryModal}
        handleDrawerClose={handleAcceptInvoice}
        payoutAcceptInvoice={handleUploadInvoice}
        setInvoiceSummaryLoading={setInvoiceSummaryLoading}
        invoiceSummaryLoading={invoiceSummaryLoading}
        invoiceSummary={invoiceSummary}
        setInvoiceSummary={setInvoiceSummary}
        yearMonth={yearMonth}
      />

      <IncompleteKycModal kycModal={kycModal} handleKycModal={handleKycModal} />
    </div>
  );
}

RegularPayoutSegment.propTypes = {
  yearMonth: PropTypes.string.isRequired
};

export default RegularPayoutSegment;
